import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { CoreService, HttpService } from '../services';
import { ToastService } from '../toast/toast.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-data-list',
  templateUrl: './data-list.component.html',
  styleUrls: ['./data-list.component.css']
})

export class DataListComponent implements AfterViewInit {

  public dataList: Array<string> = [];
  public placeholder: string = '';
  private _placeholder: string = '';
  private _oldValue: string = '';
  public deleteButton: boolean = false;
  public triggerBlurIfValid: boolean = false;
  public value: string = '';

  private deleteClicked: boolean = false;
  public showTextValid: boolean = false;
  public nullable: boolean = true;
  public _isValid: boolean = true;
  public keyPressed: boolean = false;

  public isDisabled: boolean = false;

  public listId: string = `list${Math.floor(Math.random() * 1000) + Date.now()}`;

  @ViewChild('input') input: ElementRef<HTMLInputElement>;

  @Input() inputClass: string;

  @Input('dataList')
  set SetDataList(value: Array<string>) {
    this.dataList = value;
  }
  @Input('placeholder') set SetPlaceholder(value: string) {
    this.placeholder = value;
    this._placeholder = value;
  }
  @Input('deleteButton') set SetInputWithDelete(value: boolean | string) {
    if (typeof (value) === 'string') {
      if (value === '')
        this.deleteButton = true;
    } else {
      this.deleteButton = value;
    }
  }

  @Input('triggerBlurIfValid') set SetTriggerBlurIfValid(value: boolean | string) {
    if (typeof (value) === 'string') {
      if (value === '')
        this.triggerBlurIfValid = true;
    } else {
      this.triggerBlurIfValid = value;
    }
  }

  @Input('nullable')
  set SetNullable(value: boolean) {
    if (typeof (value) === 'string') {
      if (value === '')
        this.nullable = true;
    } else {
      this.nullable = value;
    }
  }

  @Input('validDatas')
  set ValidDatas(value: boolean) {
    let validData: boolean = false;
    if (typeof (value) === 'string') {
      if (value === '')
        validData = true;
    } else {
      validData = value;
    }
    if (validData) {
      this.showTextValid = true;
    }
  }

  @Input('disabled')
  set IsDisabled(value: boolean) {
    if (typeof (value) === 'string') {
      if (value === '')
        this.isDisabled = true;
    } else {
      this.isDisabled = value;
    }
  }
  @Input('value') set SetValue(value: string) {
    this.value = value;
  }
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() qChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() isValid: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output('blur') blur: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private httpservice: HttpService,
    private indParam: CoreService,
    private toast: ToastService
  ) { }

  ngAfterViewInit(): void {
    this.input.nativeElement.setAttribute('list', this.listId);
    if (this.value) {
      const event: { target: { value: string } } = { target: { value: this.value } };
      this.OnChange(event, true);
    }
  }

  public OnReset(): void {
    Promise.resolve().then(() => {
      this.deleteClicked = true;
      setTimeout(() => {
        this.value = '';
        this._oldValue = '';
        this._isValid = this.CheckIsValid();
        this.isValid.emit(this._isValid);
        this.qChange.emit('');
        this.valueChange.emit('');
        setTimeout(() => {
          this.deleteClicked = false;
        }, 25);
      }, 0);
    });
  }

  public OnChange(event: any, init: boolean = false): void {
    Promise.resolve().then(() => {
      this.placeholder = this._placeholder;
      this.value = event.target.value;
      this._isValid = this.CheckIsValid();
      this.isValid.emit(this._isValid);      
      this.value = this.dataList.filter(x => x === this.value)[0];
      this._oldValue = this.value ? this.value : this._oldValue;
      if ((this.triggerBlurIfValid && this._isValid) || !this.triggerBlurIfValid) {
        if (init) {
          this.input.nativeElement.value = this._oldValue;
        }
        else {         
          this.valueChange.emit(this._oldValue);
          this.qChange.emit(this._oldValue);
        }
        this.input.nativeElement.blur();
      }
    });
  }
  public OnFocus(): void {
    Promise.resolve().then(() => {
      this.keyPressed = false;
      if (this._isValid) {
        this.placeholder = this.input.nativeElement.value;
        this._oldValue = this.input.nativeElement.value;
        this.input.nativeElement.value = '';
      }
    });
  }

  public onBlur(event: any): void {
    Promise.resolve().then(() => {
      this.placeholder = this._placeholder;
      this._isValid = this.CheckIsValid();
      this.isValid.emit(this._isValid);
      if ((!this.keyPressed || !this.value) && this._isValid) {
        this.value = this._oldValue;
        this.input.nativeElement.value = this._oldValue;
        //this.change.emit(this.value);
      }
    });
    if ((this.triggerBlurIfValid && this._isValid) || !this.triggerBlurIfValid)
      this.blur.emit(event);
  }

  public OnKeyPress(): void {
    this.keyPressed = true;
  }

  private CheckIsValid(): boolean {
    var optionFound = false,
      datalist = (this.input.nativeElement.list as HTMLDataListElement);
    // Determine whether an option exists with the current value of the input.
    if (datalist != null) {
      for (var j = 0; j < datalist.options.length; j++) {
        if (this.value == datalist.options[j].value) {
          optionFound = true;
          break;
        }
      }
      // use the setCustomValidity function of the Validation API
      // to provide an user feedback if the value does not exist in the datalist
      if (optionFound || (!this.value && this.nullable)) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }
}



